window.theme = window.theme || {};
window.custom_events = window.custom_events || {};

document.addEventListener('DOMContentLoaded', () => {
    const currentUrl = new URLSearchParams(window.location.search);
    const epikInUrl = currentUrl.get('epik');

    replaceLinks();
    replaceDataLinks();
    replaceFormActions();

    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, () => {
        replaceLinks();
    });

    document.addEventListener(window.custom_events.PAGINATION_LOADED, () => {
        replaceLinks();
    });

    document.addEventListener('sectionsRenderingAPI:cached', () => {
        replaceLinks();
    });

    document.addEventListener(window.custom_events.CART_SHOWN, () => {
        replaceLinks();
        replaceFormActions();
    });

    document.addEventListener(window.custom_events.TABS_ELEMENT_TAB_LOADED, () => {
        replaceLinks();
    });

    document.addEventListener('cart:refresh', () => {
        replaceLinks();
    });

    function replaceLinks() {
        document.querySelectorAll('a').forEach((a) => {
            let url = new URL(a.href, window.location.origin);
            url = addEpikParameter(url);
            a.href = decodeURIComponent(url.toString())
        });
    }

    function replaceDataLinks() {
        document.querySelectorAll('summary[data-link]').forEach((summary) => {
            let url = new URL(summary.dataset.link, window.location.origin);
            url = addEpikParameter(url);
            summary.dataset.link = decodeURIComponent(url.toString())
        });
    }

    function replaceFormActions() {
        document.querySelectorAll('form').forEach((form) => {
            let url = new URL(form.action, window.location.origin);
            url = addEpikParameter(url);
            form.action = decodeURIComponent(url.toString())
        });
    }

    function addEpikParameter(url) {
        const params = url.searchParams;

        if (params.get('epik') !== null || epikInUrl === null) {
            return url;
        }

        params.set('epik', epikInUrl);

        return url;
    }
});
